const filterSectionStyle = {
   border:"2px solid #f3f3f2;",
   borderRadius: "10px",
   padding: "10px 0 0 0",
   margin: "10px 0 0 0"
};

export default filterSectionStyle;